import {
  Api,
  getGetParams,
  getPostParams,
  getPutParams,
  getDeleteParams
} from "../../utils";
import urls from "../../config/urls";
import { ChangeLogPayloadType } from "./types";

export function FetchChangeLogApi(payload: any) {
  const url = new URL(urls.changeLog);
  url.search = new URLSearchParams(payload).toString();
  return Api.fetch(url, getGetParams());
}

export function fetchUsersApi() {
  return Api.fetch(urls.users, getGetParams());
}

